<template>
<!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      </li>
    </ul>
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- Messages Dropdown Menu -->      
      <li class="nav-item dropdown" v-if="panicAlert.length > 0">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="far fa-bell"></i>
          <span class="badge badge-danger navbar-badge blink_me">{{ panicAlert.length }}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" >
          <template v-for="(alert, index) in panicAlert">
            <router-link
            :to="{ name: 'view-user', params: { id: alert.id_user } }"
            class="dropdown-item"
            :key="'r-' + index"
            >
              <!-- Message Start -->

              <div class="media">
                <img :src="alert.foto" alt="User Avatar" class="img-size-50 mr-3 img-circle">
                <div class="media-body">
                  <h3 class="dropdown-item-title">
                    {{ alert.name }}
                  </h3>
                  <p class="text-sm text-muted">{{ alert.email }}</p>
                  <p class="text-sm"><span class="text-danger blink_me"><i class="fas fa-siren"></i></span> Em Pânico</p>
                </div>
              </div>
              <!-- Message End -->
            </router-link>
            <div class="dropdown-divider" :key="'d-' + index"></div>
          </template>
          <router-link
            :to="{ name: 'list-emergency-contact', query: { contactStatus: 2 } }"
            class="dropdown-item dropdown-footer"
          >
            Ver Todos
          </router-link>
        </div>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-widget="fullscreen" href="#" role="button">
          <i class="fas fa-expand-arrows-alt"></i>
        </a>
      </li>
      <li class="nav-item dropdown user-menu">
        <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown">
          <img :src="$store.state.authUser.foto || '@/assets/adminlte/img/avatar5.png'" class="user-image img-circle elevation-2" alt="">
          <span class="d-none d-md-inline">{{$store.state.authUser.nome}}</span>
        </a>
        <ul class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <!-- User image -->
          <li class="user-header bg-primary">
            <img :src="$store.state.authUser.foto || '@/assets/adminlte/img/avatar5.png'" class="img-circle elevation-2" alt="">
            <p>
              {{$store.state.authUser.nome}}
              <small>{{$store.state.authUser.email}}</small>
            </p>
          </li>
          <!-- Menu Footer-->
          <li class="user-footer">
            <button @click="lockScreen" class="btn btn-warning btn-social btn-sm"><i class="fas fa-lock"></i> Bloquear</button>
            <button @click="logOut" class="btn btn-danger btn-social float-right btn-sm"><i class="fas fa-sign-in-alt"></i> Logout</button>
          </li>
        </ul>
      </li>
    </ul>

    <!-- Modal -->
    <div class="modal fade" id="modalLogin" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content lockscreen">
          <div class="lockscreen-wrapper">
            <div class="lockscreen-logo">
                <b>AnjoBr</b>
            </div>

            <div class="lockscreen-name">{{$store.state.authUser.nome}}</div>

            <div class="lockscreen-item">

              <div class="lockscreen-image">
                <img :src="$store.state.authUser.foto || '@/assets/adminlte/img/avatar5.png'">
              </div>

              <form class="lockscreen-credentials" id="frmLogin">
                <div class="input-group">
                  <input type="password" class="form-control validate[required, minSize[4]]" id="pswd" v-model="loginData.senha" placeholder="Senha"/>
                  <div class="input-group-append">
                    <button type="button" class="btn" v-on:click="logIn">
                      <i class="fas fa-arrow-right text-muted"></i>
                    </button>
                  </div>
                </div>
              </form>

            </div>

            <div class="help-block text-center">
              Digite sua senha para reativar sua sessão.
            </div>
            <div class="text-center">
              <a href="#" @click="logOut">Fazer login com um usuário diferente.</a>
            </div>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <!-- /.navbar -->
</template>

<script>
import usuario from "@/controllers/usuario.controller";
import UserController from "@/controllers/user.controller";
import validator from "@/utils/validator";
import toastr from "@/utils/toastr";

export default {
  name: "Header",
  data: function() {
    return {
      loginData: {
        email: this.$store.state.email || null,
        senha: null
      },
      panicAlert: {},
      userIntervalId: null,
      panicIntervalId: null      
    };
  },
  mounted(){
    this.startInterval();
  },
  beforeDestroy() {
    this.stopInterval();
  },
  methods: {
    startInterval()
    {
      const vm = this;

      vm.checkUser();
      vm.checkPanic();

      this.userIntervalId = setInterval(function(){
        vm.checkUser();
      }, 20000);

      this.panicIntervalId = setInterval(function(){
        vm.checkPanic();
      }, 12000);
    },
    stopInterval()
    {
      if (this.panicIntervalId)
      {
        clearInterval(this.panicIntervalId);
        this.panicIntervalId = null;
      }
      if (this.userIntervalId)
      {
        clearInterval(this.userIntervalId);
        this.userIntervalId = null;
      }
    },
    logIn: function() {
      if (!validator.isValid("#frmLogin"))
          return;

      usuario.login(this.loginData)
        .then(response => {

          if(!response.data.success)
          {
            this.loginData.senha = null;
            toastr.error(response.data.error);
            return;
          }          

          this.startInterval();

          this.$store.dispatch('setToken', response.data.result.accessToken)
          .then(() => {
            $('#modalLogin').modal('hide');
          });
        })
        .catch(e => {
          toastr.error(e);
        });
    },
    logOut: function() {
      this.$store.dispatch("logOut");
      location.href = '/';
    },
    lockScreen: function() {
      this.$store.dispatch("logOut");
      this.stopInterval();

      if(!$('#modalLogin').hasClass('show'))
      {
        this.loginData.senha = null;

        $('#modalLogin')
        .appendTo("body")
        .modal({
          show: true,
          backdrop: 'static',
          keyboard: false
        });

        $('#modalLogin').on('shown.bs.modal', function () {
          $('#pswd').trigger('focus');
        });
      }
    },
    checkPanic: function() {
      UserController.getPanicAlert()
      .then(response => {
        if (!response)
          return;
        this.panicAlert = response.data.result;
      });
    },
    checkUser: function() {
        usuario.check()
        .then(response => {
          if (!response)
          {
            this.lockScreen();
            return;
          }
          if(response.data.success)
            return;
        });
    }
  }
};
</script>

<style>
.nav-link {
  cursor: pointer;
}

.blink_me {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>

